var render, staticRenderFns
import script from "./customCommon.vue?vue&type=script&lang=js"
export * from "./customCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86a7a5d8')) {
      api.createRecord('86a7a5d8', component.options)
    } else {
      api.reload('86a7a5d8', component.options)
    }
    
  }
}
component.options.__file = "src/views/customer/setup/customForm/components/customCommon.vue"
export default component.exports